import { Collapse } from "antd";
import React from "react";
import {
  BsChevronDown,
} from "react-icons/bs";

import { Link } from "react-router-dom";

import styles from "../LandingV2.module.scss";

import { faqs } from "../data";

export const LandingFAQ = () => {
  return (
    <section className={styles.faq}>
      <h3 className="fs-1">
        <img src="/icon/faq.svg" alt="" /> Frequently Asked Questions (FAQ)
      </h3>
      <em>
        Can't find your answer? Message us your question via{" "}
        <Link
          to={"/"}
          style={{
            color: "var(--color-primary)",
          }}
        >
          Contact Us
        </Link>{" "}
      </em>
      <Collapse
        bordered={false}
        expandIcon={({ isActive }) => (
          <BsChevronDown
            style={{
              fontSize: 16,
              transform: isActive ? "rotate(180deg)" : null,
              transition: "all 0.3s ease",
            }}
          />
        )}
        expandIconPosition="end"
        style={{ backgroundColor: "var(--color-light)", width: "100%" }}
        accordion
      >
        {faqs.map((faq, index) => {
          return (
            <Collapse.Panel header={faq.q} key={`${index + 1}`}>
              {faq.a}
            </Collapse.Panel>
          );
        })}
      </Collapse>
    </section>
  );
};
